import { Component } from "@/types/types"
import { cx } from "@/utils/cx"

export const COMPONENT_NAME = "stack"

export const presets = {}

export interface Props extends Component {
  as?: "section" | "header" | "article" | "main" | "div"
}

export function Stack({
  as: Elem = "div",
  children,
  className,
  style,
  testId = COMPONENT_NAME,
}: Props) {
  return (
    <Elem className={cx(`flex flex-col`, className)} style={style} data-test={testId}>
      {children}
    </Elem>
  )
}
